export * from './lib/app-client-shared-components-chat-data-access.module';
